// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export class ExtEnrollmentSurveyQuestionModel {
    'surveyId'?: number;
    'questionId'?: number;
    'answerKey'?: number;
    'answerText'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentSurveyQuestionModel>> = [
        {
            "name":     "surveyId",
            "baseName": "surveyId",
            "type":     "number"
        },
        {
            "name":     "questionId",
            "baseName": "questionId",
            "type":     "number"
        },
        {
            "name":     "answerKey",
            "baseName": "answerKey",
            "type":     "number"
        },
        {
            "name":     "answerText",
            "baseName": "answerText",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentSurveyQuestionModel.attributeTypeMap;
    }
}
